import {EnsueCollection} from "./ensue-collection";

interface PaginatedCollectionProps {
    data: Array<any>,
    page: PaginationItems,
}

interface PaginationItems {
    itemCount: number,
    pageCount: number,
    perPage: number,
    hasNextPage: boolean,
    hasPreviousPage: boolean,
    page: number
}

export class PaginatedEnsueCollection<T> extends EnsueCollection<T> {
    public page: number = 0;
    public itemCount: number = 0;
    public pageCount: number = 0;
    public hasNextPage: boolean = false;
    public hasPreviousPage: boolean = false;
    public perPage: number = 0;

    public constructor(body: PaginatedCollectionProps = {
        data: [], page: {
            page: 0, itemCount: 0, pageCount: 0,
            perPage: 0, hasNextPage: false, hasPreviousPage: false
        }
    }) {
        super(body.data);
        this.setPagination(body.page);
    }

    public setPagination(options: PaginationItems): void {
        this.itemCount = options.itemCount;
        this.perPage = Number(options.perPage);
        this.hasNextPage = options.hasNextPage;
        this.hasPreviousPage = options.hasPreviousPage;
        this.page = Number(options.page);
        this.pageCount = options.pageCount;
    }
}